<template>
  <div class="business">
    <div class="title">
      <div class="title-logo"></div>
      <div class="title-right">
        <div class="menu">
          <nx-nav />
        </div>
        <div class="title-user">
          <user-info v-if="!ifLogin"></user-info>
          <login-user v-if="ifLogin" class="tc"></login-user>
        </div>
      </div>
    </div>
    <div class="info-wrap">
      <div class="loading" v-if="loadingShow === true">
        <div class="loadingImg"></div>
      </div>
      <div class="web-table">
        <div class="tableBox" v-for="(item,index) in project" :key="index">
          <div class="tableItem zhengchang">
            <div class="tableName">{{ item.name }}</div>
            <div class="line"></div>
            <div class="siteBox">
              <div class="siteOne">
                <div class="address">
                  <span>功能：</span>
                  {{ item.introduce }}
                </div>
                <div class="project">
                  <!-- <img :src="item.img" alt /> -->
                  <el-image :src="item.img" fit="scale-down"></el-image>
                </div>
              </div>
            </div>
            <div class="tableBtn">
              <div class="siteBtnOne" @click="jump(index)">查看</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tabBottom></tabBottom>
  </div>
</template>

<script>
import NxNav from "../NxNav";
import UserInfo from "../user";
import tabBottom from "../tabBottom";
import { setUserInfo } from '@/js/utils'
import loginUser from "../user2";
export default {
  components: {
    NxNav,
    UserInfo,
    tabBottom,
    loginUser
  },
  data() {
    return {
      loadingShow: true,
      project: [
        {
          name:'照片合成',
          introduce:'将图片合在一起与相框合在一起',
          img: require('../../assets/frame.png'),
          to: '/lab/photoFit'
        },
        {
          name:'拉伸图片',
          introduce:'将图片自由拉伸移动',
          img: require('../../assets/bg1.jpg'),
          to: '/lab/stretching'
        },
        {
          name:'canvas签名',
          introduce:'手写识别',
          img: require('../../assets/bg.png'),
          to: '/lab/canvas'
        },
        {
          name:'拼图验证',
          introduce:'登录拼图验证',
          img: require('../../assets/puzzle.jpg'),
          to: '/lab/puzzle'
        },
        {
          name:'AI绘画',
          introduce:'AI绘画',
          img: require('../../assets/puzzle.jpg'),
          to: '/lab/aiDraw'
        },
        {
          name:'人像分离',
          introduce:'人像分离',
          img: require('../../assets/split-img.jpg'),
          to: '/lab/splitDraw'
        },
      ]
    };
  },
  mounted() {
    var me = this;
    this.loadingShow = true;
    setTimeout(function() {
      me.loadingShow = false;
    }, 500);
  },
  sockets: {
    connect: function() {
      var token = localStorage.getItem("jwt");
      if (token) {
        this.$socket.emit("authenticate", { token });
      }
    },
    authenticated: function(data) {
      var token = localStorage.getItem("jwt");
      this.$socket.emit("queryUser", token);
    },
    unauthorized: function(error) {
      console.log('unauthorizederror :>> ', error );
      if (error.message === 'jwt expired') {
        this.$router.push({ path: "/" });
      }
    },
    userInfo: function(data) {
      setUserInfo.call(this, data)
    },
  },
  methods: {
    jump(index) {
      this.$router.push({ path: this.project[index].to });
    }
  },
  computed: {
    ifLogin() {
      return this.$store.state.ifLogin;
    },
  }
};
</script>

<style lang="less" scoped>
.business {
  position: relative;
  padding-bottom: 20px;
  .tc {
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    float: right;
    width: 200px;
  }
  .info-wrap {
    display: flex;
    margin: 0 auto;
    width: 60vw;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 70px;
    .loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      background-color: #181e26;
      .loadingImg {
        width: 320px;
        height: 260px;
        background-image: url(../../assets/loading.gif);
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 420px;
        color: #21a2f5;
        font-size: 18px;
      }
    }
    .web-table {
      width: 90vw;
      padding-top: 3vh;
      margin-bottom: 50px;
      .tableBox {
        width: 47%;
        height: 280px;
        // display: inline-block;
        margin: 0 2vw 3vh 0;
        float:left;
      }
      .tableItem {
        width: 100%;
        height: 100%;
        color: #fff;
        background-color: rgba(117, 176, 243, 0.2);
        background-color: #313a46;
        border-radius: 7px;
        padding: 10px 0.5vw;
        line-height: 14px;
        text-align: left;
        font-size: 14px;
        position: relative;
        overflow: hidden;
        .tableName {
          text-align: left;
          width: 80%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-left: 5%;
        }
        .line {
          width: 80%;
          height: 2px;
          background: rgb(24, 30, 38, 0.4);
          position: absolute;
          top: 32px;
          left: 0;
        }
        .siteBox {
          width: 100%;
          height: 78%;
          overflow: hidden;
          position: relative;
          top: 6%;
          margin-bottom: 10px;
          .siteOne {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            div {
              // display: inline-block;
              margin-left: 5%;
            }
          }
          .address {
            margin-top: 10px;
            font-size: 12px;
            width: 90%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin: 5px 0;
            margin-bottom: 3%;
          }
          .project {
            width: 73%;
            height: 80%;
            background-image: url(../../assets/out-box.png);
            background-size: 100%;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
            overflow: hidden;
            padding: 3%;
            display: flex;
            align-items: center;
            justify-content: center;
            .el-image{
              height: 100%;
            }
            // img {
            //   width: 100%;
            // }
          }
        }
        .tableBtn {
          position: absolute;
          bottom: 5%;
          right: 5%;
          width: 100%;
          font-size: 12px;
          z-index: 99;
          div {
            border: 1px solid rgb(148, 146, 146);
            padding: 2px 5px;
            border-radius: 10px;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
              0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
            float: right;
            display: inline-block;
            margin-left: 8%;
            cursor: pointer;
          }
          .siteBtnOne {
            background: #222a36;
          }
        }
      }
      .zhengchang {
        background: linear-gradient(
          to top right,
          #313a46 20%,
          #444e58 80%
        ); //正常
      }
    }
  }
  .ysxy {
    color: #fff;
    font-size: 16px;
    text-decoration: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pc/PCLaboratory.vue